import { createTheme } from '@mui/material'
import { palette } from './palette'
import { typography } from './typography'
import { components } from './components'
import { layout } from './tokens'

export const theme = createTheme({
  palette,
  typography,
  components,
  shape: { borderRadius: layout.radius.card },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440 },
  },
})
